export type PrivacyChoices = { analytics: boolean; advertising: boolean };
export const PRIVACY_STORAGE_KEY = "novilot_privacy_choices_v1";
let storageFailed = false;
export const PRIVACY_CHANGED = "novilot:privacy-changed";
const denied: PrivacyChoices = { analytics: false, advertising: false };

export function browserPrivacySignal(): boolean {
  if (typeof navigator === "undefined") return false;
  const nav = navigator as Navigator & { globalPrivacyControl?: boolean };
  return nav.doNotTrack === "1" || nav.doNotTrack === "yes" || nav.globalPrivacyControl === true;
}

/** Null means no valid saved choice. Denied is the default in that case. */
export function storedPrivacyChoices(): PrivacyChoices | null {
  if (typeof window === "undefined" || storageFailed) return null;
  try {
    const raw = window.localStorage.getItem(PRIVACY_STORAGE_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    const value = parsed as Record<string, unknown>;
    return value.version === 1 && typeof value.analytics === "boolean" && typeof value.advertising === "boolean"
      ? { analytics: value.analytics, advertising: value.advertising } : null;
  } catch { return null; }
}
export function currentPrivacyChoices(): PrivacyChoices {
  if (browserPrivacySignal()) return denied;
  return storedPrivacyChoices() ?? denied;
}
export function savePrivacyChoices(choice: PrivacyChoices): boolean {
  if (typeof window === "undefined") return false;
  const value = browserPrivacySignal() ? denied : choice;
  try {
    window.localStorage.setItem(PRIVACY_STORAGE_KEY, JSON.stringify({ version: 1, analytics: value.analytics, advertising: value.advertising }));
    storageFailed = false;
    window.dispatchEvent(new Event(PRIVACY_CHANGED));
    return true;
  } catch {
    storageFailed = true;
    try { window.localStorage.removeItem(PRIVACY_STORAGE_KEY); } catch { /* Some browsers deny all storage access. */ }
    window.dispatchEvent(new Event(PRIVACY_CHANGED));
    return false;
  }
}
